import { observer } from "mobx-react-lite";
import React, { FC, useMemo, useState } from "react";
import { langStore } from "@noli/business";
import styles from "./index.module.scss";
import { loginStore } from "@/modules/login/store";
import Input from "@/pages/Setting/components/Input";
import { pwdSet } from "@/pages/Setting/api";
import { Toast } from "@/components/Toast";
import { SettingLangRecords } from "@/pages/Setting/lang";

const SetPassword: FC<any> = (props) => {
  const { onClose } = props;
  const lang = langStore.tgt;
  const {
    userState: { userInfo },
  } = loginStore;
  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const submitState = useMemo(() => {
    return code.length === 6 && password.length >= 6 && password.length <= 32;
  }, [code, password]);
  const submit = async () => {
    try {
      await pwdSet({
        code: code,
        mobileNumber: userInfo.phone as string,
        password: password,
      });
      await loginStore.getUserInfo();
      onClose && onClose();
      Toast({
        status: "success",
        title: SettingLangRecords[lang]["Change-Succeeded"],
      });
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <div className={styles.contentRowWrapper} style={{ borderStyle: "none", flexFlow: "column" }}>
      <Input
        phoneOrEmail={userInfo.phone}
        label={SettingLangRecords[lang]["Verification"]}
        type="code"
        placeholder={SettingLangRecords[lang]["Enter-verification-code"]}
        value={code}
        onChange={(value: string | number) => {
          setCode(value as string);
        }}
      />
      <Input
        label={SettingLangRecords[lang]["Password"]}
        type="password"
        placeholder={SettingLangRecords[lang]["Please-enter-6-30-digit-password"]}
        value={password}
        onChange={(value: string | number) => {
          setPassword(value as string);
        }}
      />
      <button
        className={styles.submit}
        disabled={!submitState}
        onClick={async () => {
          await submit();
        }}
      >
        {SettingLangRecords[lang]["Confirm"]}
      </button>
    </div>
  );
};
export default observer(SetPassword);
